import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'displayQuestionType' })

export class DisplayQuestionType implements PipeTransform {
  transform(value: string): string {
    return value === 'one_choice' ? 'QCU' : 'QCM';
  }
}
